import {cachedTileUrl} from './mapTileUrls.js';

export interface ImageryCoordinates {x:number;y:number;z:number}
export interface SavedImagery {
 cacheKey:string;
 zoom:number;
 response:Response;
 crop:{x:number;y:number;size:number};
}
type ReadSaved=(url:string)=>Promise<Response|undefined>;
/** Read only existing Esri imagery; never download or save derived child tiles. */
export async function* savedImageryCandidates(coords:ImageryCoordinates,readSaved?:ReadSaved,origin=globalThis.location?.origin):AsyncGenerator<SavedImagery>{
 const {x,y,z}=coords;
 if(!origin||![x,y,z].every(Number.isInteger)||z<0||z>19||x<0||y<0||x>=2**z||y>=2**z)return;
 if(!readSaved){
  if(typeof caches==='undefined'||!(await caches.has('sonata-visited-tiles-v1')))return;
  const cache=await caches.open('sonata-visited-tiles-v1');
  readSaved=url=>cache.match(url,{ignoreVary:true});
 }
 for(let zoom=z;zoom>=0;zoom--){
  const scale=2**(z-zoom),xx=Math.floor(x/scale),yy=Math.floor(y/scale);
  const url=new URL(cachedTileUrl(`https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/${zoom}/${yy}/${xx}`),origin);
  let response=await readSaved(url.href);
  if(!response){url.searchParams.delete('v');response=await readSaved(url.href);}
  if(response?.ok&&!/\bno-store\b/i.test(response.headers.get('cache-control')||'')){
   yield {cacheKey:url.href,zoom,response,crop:{x:(x%scale)/scale,y:(y%scale)/scale,size:1/scale}};
  }
 }
}

export function decodeSavedImagery(response:Response):Promise<HTMLImageElement>{
 return response.blob().then(blob=>new Promise((resolve,reject)=>{
  const url=URL.createObjectURL(blob),image=new Image();image.decoding='async';
  image.onload=()=>{URL.revokeObjectURL(url);resolve(image);};
  image.onerror=()=>{URL.revokeObjectURL(url);reject(new Error('Saved imagery could not be decoded.'));};
  image.src=url;
 }));
}
